import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import AggregationFilter from '../../modules/search/store/AggregationFilter';
import { updateUrl } from '../../util/url';
import type AbstractFilter from './store/AbstractFilter';
import type ApiRequestState from './store/ApiRequestState';

export default class SearchUrlUpdater implements Observer {
    readonly #filters: AbstractFilter[];

    #ignoredParams: string[] = [];

    constructor(requestState: ApiRequestState, filters: AbstractFilter[]) {
        this.#filters = filters;
        requestState.attach(this);
    }

    setIgnoredParams(params: string[]): void {
        this.#ignoredParams = params;
    }

    get url(): URL {
        const url = new URL(window.location.href);

        this.#filters.forEach((filter) => {
            if (filter instanceof AggregationFilter) {
                const parameters: string | null = Object.keys(filter.parameters).length
                    ? (filter.parameters[filter.parameterName] as string)
                    : null;

                this.#setUrlParam(url, filter.parameterName, parameters);
                return;
            }

            for (const [key, value] of Object.entries(filter.parameters)) {
                this.#setUrlParam(url, key, value);
            }
        });

        return url;
    }

    update(): void {
        updateUrl(this.url, true);
    }

    #setUrlParam(url: URL, key: string, value: string | null): URL {
        if (this.#ignoredParams.includes(key)) {
            return url;
        }

        if (value === null) {
            url.searchParams.delete(key);
            return url;
        }

        url.searchParams.set(key, value);
        return url;
    }
}
